import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';

function mountStudio() {
  const mountPoint = document.getElementById('restomod-studio-app');
  if (!mountPoint) {
    return;
  }

  // Prevent double mounting if bundle executed twice
  if ((mountPoint as any).__restomod_mounted) {
    return;
  }
  (mountPoint as any).__restomod_mounted = true;

  const root = createRoot(mountPoint);
  root.render(<App />);
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountStudio);
  } else {
    mountStudio();
  }
}

export default mountStudio;
